<template>
  <div class="numbers">
    <div class="content">
      <div class="number">
        <p>{{content.number}}</p>
        <div class="cube cube-1"></div>
        <div class="cube cube-2"></div>
      </div>
      <div class="text">
        <p>{{content.text}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  }
};
</script>

<style lang="scss">
.numbers {
  height: 100%;
  width: 100%;
  &:nth-child(5) {
    width: 40%;
    margin: auto;
  }
  .content {
    display: flex;

    width: 100%;

    .number {
      background: linear-gradient(180deg, #46bed5 0%, #3797a9 100%);
      height: 135px;
      width: 150px;
      text-align: center;
      color: white;
      position: relative;
      flex: 0 0 135px;
      .cube-1 {
        background-color: rgba(55, 151, 169, 0.5);
        height: 140px;
        transform: translate(5%, -78%);
        z-index: -2;
      }
      .cube-2 {
        background-color: rgba(55, 151, 169, 0.2);
        height: 140px;
        transform: translate(10%, -170%);
        z-index: -3;
      }

      p {
        font-size: 45px;
        padding: 0.8em 0;
        position: relative;
        z-index: 1;
      }
    }
    .text {
      width: 80%;
      text-align: left;

      background-color: rgba(252, 252, 252, 0.4);
      p {
        transform: translateY(50%);
        padding: 0.5em;
        font-size: 30px;
        font-weight: 800;
      }
    }
  }
}
</style>
